import React from 'react';
import { DCBUnsubscribeOTP as DCBUnsubscribeOTPScreen } from '@features/dcb-unsubscribe-otp';

export const DCBUnsubscribeOTP = (props: any) => <DCBUnsubscribeOTPScreen {...props} />;
